// validateMissionWorkspaceCommand.js — template-time validation for agentic mission commands

const AUTOMATION_LEAD_IN_PATTERN = /\b(?:whenever|when|if|automatically|notify me|alert me)\b/i;
const IF_ACTION_PATTERN = /\bif\b.+\b(?:then|send|email|set|update|notify|stamp|fill|clear)\b/i;
const DATABASE_CREATE_PATTERN = /\bcreate\s+(?:a\s+)?(?:new\s+)?[\w\s-]+\s+database\b/i;
const READ_QUESTION_PATTERN = /\b(?:show|list|find|open|view|how many|count)\b/i;

export const MISSION_WORKSPACE_COMMAND_MAX_LENGTH = 500;

function cleanString(value) {
  return String(value || '').trim();
}

export function validateMissionWorkspaceCommand(instruction = '') {
  const text = cleanString(instruction);

  if (!text) {
    return {
      ok: false,
      message: 'Add a command before saving this Agent task.',
    };
  }

  if (text.length > MISSION_WORKSPACE_COMMAND_MAX_LENGTH) {
    return {
      ok: false,
      message: `Keep the command under ${MISSION_WORKSPACE_COMMAND_MAX_LENGTH} characters.`,
    };
  }

  if (AUTOMATION_LEAD_IN_PATTERN.test(text) || IF_ACTION_PATTERN.test(text)) {
    return {
      ok: false,
      message: 'This looks like an automation trigger. Use Collection automations for when-field-changes rules.',
    };
  }

  if (DATABASE_CREATE_PATTERN.test(text)) {
    return {
      ok: false,
      message: 'Collection creation is not supported here. Use structured Create Record or Collection Settings.',
    };
  }

  if (READ_QUESTION_PATTERN.test(text)) {
    return {
      ok: false,
      message: 'Read-only questions are not supported for Agent mission steps.',
    };
  }

  return { ok: true, message: '' };
}
